import React, { useState, useEffect } from 'react';
import { CalendarCheck, HardHat } from '@phosphor-icons/react';
import { schedulingAPI } from '../../api/api';

const fmtDate = (iso) => new Date(iso + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export const WorkerScheduleCard = () => {
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    schedulingAPI.list().then(({ data }) => setSchedules(data.schedules || [])).catch(() => {});
  }, []);

  if (schedules.length === 0) return null;

  return (
    <div className="bg-white dark:bg-neutral-800 rounded-xl border-2 border-[#0F172A] dark:border-neutral-700 shadow-[3px_3px_0px_#0F172A] dark:shadow-[3px_3px_0px_#10B981] p-5 mb-6" data-testid="worker-schedule-card">
      <h3 className="font-bold text-neutral-900 dark:text-white flex items-center gap-2 mb-3">
        <span className="w-8 h-8 rounded-lg bg-emerald-100 dark:bg-emerald-900/40 flex items-center justify-center">
          <CalendarCheck size={18} weight="fill" className="text-emerald-600" />
        </span>
        My Upcoming Schedule
      </h3>
      <div className="space-y-3">
        {schedules.map((s) => (
          <div key={s.id} className="border-2 border-neutral-100 dark:border-neutral-700 rounded-xl p-3.5" data-testid={`worker-schedule-${s.id}`}>
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <p className="font-bold text-sm text-neutral-900 dark:text-white">{s.title}</p>
              <span className="text-xs text-neutral-500">by {s.contractor_name}{s.location ? ` · ${s.location}` : ''}</span>
            </div>
            <div className="mt-2 space-y-1.5">
              {s.phases.map((p) => (
                <div key={p.phase_id} className="flex items-center gap-2 text-sm">
                  <HardHat size={15} weight="fill" className="text-emerald-600 shrink-0" />
                  <span className="font-semibold text-neutral-800 dark:text-neutral-200 truncate">{p.name}</span>
                  {p.status === 'delayed' && (
                    <span className="text-[10px] font-bold uppercase text-amber-700 dark:text-amber-300 bg-amber-100 dark:bg-amber-900/50 rounded-full px-1.5 py-0.5 shrink-0" data-testid={`worker-phase-delayed-${p.phase_id}`}>Delayed</span>
                  )}
                  <span className="ml-auto text-xs font-bold text-emerald-700 dark:text-emerald-300 bg-emerald-50 dark:bg-emerald-900/40 rounded-full px-2 py-0.5 shrink-0">
                    {fmtDate(p.start_date)} → {fmtDate(p.end_date)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
